/**
 * Normalize check_url API responses into safe client navigation.
 * Avoids relative history.push paths and login ↔ operational-date loops.
 */
function normalizePath(path) {
    const normalized = String(path || "/").split("?")[0]
    if (normalized.length > 1 && normalized.endsWith("/")) {
        return normalized.slice(0, -1)
    }
    return normalized || "/"
}

export function resolveCheckUrlNavigation(responseData, currentPathname) {
    const current = normalizePath(currentPathname)
    const target = responseData?.url
        ? normalizePath(`/${String(responseData.url).replace(/^\//, "")}`)
        : ""

    if (Number(responseData?.allowurl) === 1) {
        if (!target || target === current) {
            return { action: "stay" }
        }
        return { action: "push", path: target }
    }

    if (target && target !== current) {
        return { action: "push", path: target }
    }

    return { action: "deny" }
}

/**
 * Apply check_url response: absolute paths only, no goBack loops, skip push when already on page.
 * @returns {boolean} true when the page is allowed to load (stay or redirected successfully)
 */
export function applyCheckUrlNavigation(history, responseData, currentPathname, onAllowed) {
    const nav = resolveCheckUrlNavigation(responseData, currentPathname)

    if (nav.action === "push") {
        history.push(nav.path)
        return false
    }

    if (nav.action === "stay" && typeof onAllowed === "function") {
        onAllowed()
        return true
    }

    return false
}
